import apiMessage from '@/api/vo/message';

const defaultState = () => ({
	listInbox: [],
	inboxPagination: '',
	listMessageSent: [],
	messageSentPagination: '',
	listDraft: [],
	draftPagination: '',
	listArchive: [],
	archivePagination: '',
	detailMessage: '',
	autocompleteMessage: [],
});

const state = defaultState();

const getters = {

};

const mutations = {

	setInbox(state, data) {
		state.listInbox = data.data;
		state.inboxPagination = data.pagination;
	},
	setMessageSent(state, data) {
		state.listMessageSent = data.data;
		state.messageSentPagination = data.pagination;
	},
	setDraft(state, data) {
		state.listDraft = data.data;
		state.draftPagination = data.pagination;
	},
	setArchive(state, data) {
		state.listArchive = data.data;
		state.archivePagination = data.pagination;
	},
	setDetailMessage(state, data) {
		state.detailMessage = data.data
	},
	setAutocompleteMessage(state, data) {
		data.data.map( (el) => {
			el.member_data = el.member_name + ' - ' + el.member_network_code
			return el
		})
		state.autocompleteMessage = data.data
	}
};

const actions = {

	getInbox({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.getInbox(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setInbox', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setInbox', {});
				reject()
			});
		});
	},

	getMessageSent({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.getMessageSent(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setMessageSent', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setMessageSent', {});
				reject()
			});
		});
	},

	getDraft({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.getDraft(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDraft', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDraft', {});
				reject()
			});
		});
	},

	getArchive({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.getArchive(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setArchive', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setArchive', {});
				reject()
			});
		});
	},

	getDetailMessage({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.getDetailMessage(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setDetailMessage', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setDetailMessage', {});
				reject()
			});
		});
	},

	getAutocomplete({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.getAutocomplete(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					commit('setAutocompleteMessage', data.results);
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setAutocompleteMessage', {});
				reject()
			});
		});
	},

	addMessage({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.addMessage(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, pesan baru tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	addMessageAdmin({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.addMessageAdmin(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, pesan baru tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	deleteMessage({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.deleteMessage(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, hapus pesan tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	archiveMessage({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.archiveMessage(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, arsip pesan tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	readMessage({ dispatch, commit }, params) {
		return new Promise((resolve, reject) => {
			apiMessage.readMessage(params).then((results) => {
				const data = results.data
				if ( data.status == 200 ) {
					dispatch('success', data)
					resolve(data)
				} else {
					dispatch("errorHandler", data)
					reject()
				}
			}).catch(() => {
				commit('setSnackbar', {
					show: true,
					color: 'red darken-2',
					text: 'Terjadi kesalahan pada sistem, detail pesan tidak dapat diproses.'
				}, { root: true });
				reject()
			});
		});
	},

	success({ commit }, data) {
		commit('setSnackbar', {
			show: true,
			color: 'green accent-4',
			text: data.message
		}, { root: true });
	},

	errorHandler({ commit }, response) {
		if (response.status !== undefined && response.status === 'unauthorized') {
			commit('setSnackbar', {
				show: true,
				color: 'red darken-2',
				text: response.msg
			}, { root: true });
		} else {
			switch (response.error_code) {
				case 'validationError':
					commit('setErrorValidation', response.results.validationMessage)
					break;
					
				case 'ERROR':
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: response.message
					}, { root: true });
					break;
						
				default:
					commit('setSnackbar', {
						show: true,
						color: 'red darken-2',
						text: 'Terjadi Kesalahan pada sistem, hubungi administrator atau layanan mitra ' + (process.env.VUE_APP_CLIENT_INIT !== undefined) ? process.env.VUE_APP_CLIENT_INIT : 'perusahaan'
					}, { root: true });
					break;
			}
		}
	},

};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};